import { render, staticRenderFns } from "./Contact_phone.vue?vue&type=template&id=ffce77f0&scoped=true"
import script from "./Contact_phone.vue?vue&type=script&lang=js"
export * from "./Contact_phone.vue?vue&type=script&lang=js"
import style0 from "./Contact_phone.vue?vue&type=style&index=0&id=ffce77f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce77f0",
  null
  
)

export default component.exports